import React, { useEffect, useState } from 'react';
import AddNewPermission from 'src/components/Permissions/AddNewPermission';
import HeaderContentBlock from 'src/components/Common/HeaderContentBlock';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { deletePermission, permissionList } from 'src/services/permissions';
import ResponsivPermissionListAccordion from 'src/components/Responsive/permissions/ResponsivPermissionListAccordion';
import { dateTimeFormate } from 'src/utils/function';
import ResponsiveHeaderContentBlock from 'src/components/Responsive/ResponsiveHeaderContentBlock';
import ModalContentBlock from 'src/components/Common/ModalContentBlock';
import ConfirmationPopUp from 'src/components/Common/ConfirmationPopUp';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa';

const Permissions = () => {
    const [addNewPermission, setAddNewPermission] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(50);
    const [first, setFirst] = useState(0);
    const [permissionListData, setPermissionListData] = useState([]);
    const [totalPermissionRecords, setTotalPermissionRecords] = useState(0);
    const [openAcoordionResponsive, setOpenAcoordionResponsive] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [confirnModalOpen, setConfirmModalOpen] = useState<any>({ id: null });

    const controller = new AbortController();

    useEffect(() => {
        if (searchInput) {
            getList(`?page=${page}&limit=${rows}&search=${searchInput}`, controller.signal);
        } else {
            getList(`?page=${page}&limit=${rows}`, controller.signal);
        }
        return () => controller.abort();
    }, [page, rows, searchInput]);

    const getList = async (url: string, signal?: any) => {
        try {
            setIsLoading(true);
            const resData = await permissionList(url, signal);
            const data = resData?.data?.data;
            setPermissionListData(data.permissions);
            setTotalPermissionRecords(data.total);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    const handleRowClick = (row: any) => {
        setIsUpdate(true);
        setAddNewPermission(true);
        setSelectedRowData(row.data);
    };

    const handleSearch = (e: any) => {
        setPage(0);
        setSearchInput(e.target.value);
    };
    const newPermissionSuccess = () => {
        if (page === 0) {
            getList(`?page=${page}&limit=${rows}`, controller.signal);
        } else {
            setPage(0);
            setFirst(0);
        }
        setAddNewPermission(false);
        setBtnDisabled(false);
        setIsUpdate(false);
        setSelectedRowData(null);
    };
    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
        setPage(event.page);
    };

    const GetName = (row: any) => <div>{row?.name}</div>;
    const GetDescription = (row: any) => <div>{row?.description || row?.description !== '' ? row?.description : '-'}</div>;
    const GetDisplayName = (row: any) => <div>{row?.display_name}</div>;
    const GetModule = (row: any) => <div>{row?.module}</div>;

    const GetDeleteAction = (row: any) => (
        <div
            onClick={(e) => {
                e.stopPropagation();
                setConfirmModalOpen({ id: row.id });
            }}
            className=" p-2 bg-red-100 text-red-700 rounded-lg justify-center items-center inline-flex"
        >
            <FaTrash size={14} />
            {/* <p className="text-xs font-medium ">Delete</p> */}
        </div>
    );
    const GetCreated = (row: any) => <div>{row.created_at ? dateTimeFormate(row.created_at, 'DD MMM, YYYY') : '-'}</div>;
    const handleDeleteClick = async (id: any) => {
        try {
            const res = await deletePermission(`?permissionId=${id}`);

            if (res?.status === 200) {
                toast.success(`Permission deleted successfully.`);
                if (searchInput) {
                    getList(`?page=${page}&limit=${rows}&search=${searchInput}`);
                } else {
                    getList(`?page=${page}&limit=${rows}`);
                }
            } else {
                toast.error(res?.data?.message || 'Operation failed. Please try again.');
            }
        } catch (err) {
            // console.log(err);
        }
        setConfirmModalOpen({ id: null });
    };

    return (
        <div>
            <div>
                <ResponsiveHeaderContentBlock
                    sortOnClick={() => {}}
                    closeOnClick={() => {
                        setAddNewPermission(false);
                        setSelectedRowData(null);
                        setIsUpdate(false);
                    }}
                    addNewOnClick={() => setAddNewPermission(true)}
                    isDisabled={addNewPermission}
                    searchOnchange={handleSearch}
                    searchInput={searchInput}
                    isNext={addNewPermission}
                />
            </div>
            <HeaderContentBlock
                closeOnClick={() => {
                    setAddNewPermission(false);
                    setSelectedRowData(null);
                    setIsUpdate(false);
                }}
                saveOnClick={() => setIsSave(true)}
                addNewOnClick={() => setAddNewPermission(true)}
                nextStep={addNewPermission}
                addNewBtnText={'Add new Permission'}
                isEmploy={true}
                headerText="Permissions"
                isDisabled={btnDisabled}
                searchOnchange={handleSearch}
                searchInput={searchInput}
                // sortOnClick={() => {}}
            />
            {addNewPermission && (
                <AddNewPermission
                    setIsSave={setIsSave}
                    isSave={isSave}
                    isOnSuccess={() => {
                        newPermissionSuccess();
                    }}
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isUpdate={isUpdate}
                    selectedRowData={selectedRowData}
                />
            )}
            <div className={`pt-5 pb-0 w-full ${addNewPermission ? 'hidden' : 'max-lg:block hidden'}`}>
                <>
                    {permissionListData?.length === 0 && (
                        <div
                            className=" bg-white max-md:h-10 flex justify-center items-center max-lg:font-semibold
                         max-lg:text-xl max-lg:h-12  max-md:font-medium max-md:text-lg"
                        >
                            No Permission Found
                        </div>
                    )}
                    <ResponsivPermissionListAccordion
                        permissionListData={permissionListData}
                        openAcoordionResponsive={openAcoordionResponsive}
                        setOpenAcoordionResponsive={setOpenAcoordionResponsive}
                        onRowClick={handleRowClick}
                        GetDeleteAction={GetDeleteAction}
                    />
                    <div className="mt-5">
                        <Paginator
                            first={first}
                            rows={rows}
                            totalRecords={totalPermissionRecords}
                            onPageChange={onPageChange}
                            className="datatable_pagination"
                            template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        />
                    </div>
                </>
            </div>
            <div className="py-6 hidden lg:block">
                <DataTable value={permissionListData} tableClassName="logdatatable" emptyMessage="No Permission Found" className="" loading={isLoading} onRowClick={handleRowClick}>
                    <Column field="name" header="Name" body={GetName}></Column>
                    <Column field="display_name" header="Display Name" body={GetDisplayName}></Column>
                    <Column field="module" header="Module" body={GetModule}></Column>
                    <Column field="description" header="Description" body={GetDescription}></Column>
                    <Column field="created_at" header="Created Date" body={GetCreated}></Column>
                    <Column field="action" header="Action" body={GetDeleteAction}></Column>
                </DataTable>
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalPermissionRecords}
                    onPageChange={onPageChange}
                    className="datatable_pagination"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
            </div>
            {confirnModalOpen.id && confirnModalOpen.id !== null && (
                <ModalContentBlock onclose={() => setConfirmModalOpen({ id: null })} isMoreClass="logout_modal" isModalOpen={confirnModalOpen}>
                    <ConfirmationPopUp
                        confirmText="Are you sure you want to delete this permission?"
                        submitOnClick={() => {
                            handleDeleteClick(confirnModalOpen.id);
                        }}
                        cancelOnClick={() => setConfirmModalOpen({ id: null })}
                    />
                </ModalContentBlock>
            )}
        </div>
    );
};

export default Permissions;
